import * as angular from 'angular';
import { Component } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';

@Component({
  selector: 'cookies',
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.scss'
})
export class CookiesComponent {
  public openSettings(): void {
    const consent = (window as any).viteezyConsent;

    if (consent && typeof consent.openSettings === 'function') {
      consent.openSettings();
    }
  }
}

angular.
  module('cookies', [])
    .directive('cookies', downgradeComponent({component: CookiesComponent}) as angular.IDirectiveFactory);
